import { Provider } from "components/driving-license-class/DrivingLicenseClassContext";
import { DrivingLicenseClassList } from "components/driving-license-class/DrivingLicenseClassList";
import React from "react";

export const DrivingLicenseClasses = () => {
    return (
        <Provider>
            <DrivingLicenseClassList />
        </Provider>
    );
};
